import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { UserManagementMenu } from '@app/components/eMIPs/ShortcutNavigator/WebAdmin/UserManagementMenu';
import { ReportingConfigureMenu } from '@app/components/eMIPs/ShortcutNavigator/WebAdmin/ReportingConfigureMenu';
import { VariantContext } from '@app/variant'; // 👈 add this
import { ItemSettingsMenu } from '@app/components/eMIPs/ShortcutNavigator/WebAdmin/ItemSettingsMenu';
import { FactoryPrintingMenu } from '@app/components/eMIPs/ShortcutNavigator/WebAdmin/FactoryPrintingMenu';

const ShortcutMenuPage: React.FC = () => {
  const { category } = useParams();
  const { id } = useContext(VariantContext); // "control" | "user"

  let shortcutCategory: React.ReactNode = null;

  // 👇 variant-aware switch
  if (id === 'control') {
    switch (category) {
      case 'user-management':
        shortcutCategory = <UserManagementMenu />;
        break;
      case 'item-settings':
        shortcutCategory = <ItemSettingsMenu />
        break;
      case 'factory-printing':
        shortcutCategory = <FactoryPrintingMenu />
        break;
      case 'report-configuration':
        shortcutCategory = <ReportingConfigureMenu />;
        break;
      default:
        shortcutCategory = <div>Unknown shortcut for control</div>;
    }
  }

  if (id === 'user') {
    switch (category) {
      // maybe user panel has fewer options
      case 'user-management':
        shortcutCategory = <UserManagementMenu />;
        break;
      case 'report-configuration':
        shortcutCategory = <ReportingConfigureMenu />;
        break;
      default:
        shortcutCategory = <div>Unknown shortcut for user</div>;
    }
  }

  return <>{shortcutCategory}</>;
};

export default ShortcutMenuPage;
